import React from "react";
import { Box } from "@mui/material";
import { loanManagementUrl } from "../../config";
import DynamicTableForJson from "../../data/DynamicTable/dynamicTableForJson";

//const base_url = loanManagementUrl.uri;
const base_url = loanManagementUrl.uri;
//const base_url = "https://localhost:7113/graphql/";

const DeclinedApplications = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  //spaced specific columns
  const columns = [
    { field: "Id", headerName: "ID", flex: 0.3 },
    { field: "CustomerId", headerName: "Customer ID" },
    { field: "CustomerPhone", headerName: "Customer Phone" },
    { field: "FirstName", headerName: "First Name", flex: 1 },
    { field: "OtherNames", headerName: "Other Names", flex: 1 },
    { field: "LoanAmount", headerName: "Loan Amount", flex: 1 },
    { field: "LoanDeclinedReason", headerName: "Delied Reason", flex: 1 },
    { field: "ProductName", headerName: "Product Name" },
  ];
  const actions = {
    entity: localStorage.getItem("SelectedRight"), //,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: false,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: false,
      permission: "CreatePermission",
    },
    dataObject: {
      objectName: "allDeclinedApplications",
      parameters: "",
      ignoreFields: ["FieldOfficerId", "CompanyId", "BranchId", "RegionId"],
    },
    showStatus: true,
  };

  return (
    <Box m="20px">
      <DynamicTableForJson
        title="Declined Applications"
        subtitle="Declined Applications"
        base_url={base_url}
        columns={columns}
        actions={actions}
      />
    </Box>
  );
};

export default DeclinedApplications;
